import React, { useState } from "react";

//UI Material
import { Button, Grid, Stack } from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForMainTitles,
  typographyForText,
} from "../../Helpers/typography";

//Material Icons
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export default function ClientSummary({ data }) {
  // ==========>Component States<==========
  const [showDetails, setShowDetails] = useState(false);

  //Date formatting
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  // ==========>Component<==========
  return (
    <Grid container spacing={1} justifyContent="flex-start" textAlign="left">
      <Grid item xs={12}>
        <Stack
          justifyContent="flex-start"
          alignItems="flex-start"
          textAlign="left"
        >
          {typographyForCustomizedFontSize(
            "Nombre del cliente",
            "11px",
            null,
            "bold"
          )}
          {typographyForMainTitles(data.name)}
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack
          justifyContent="flex-start"
          alignItems="flex-start"
          textAlign="left"
        >
          {typographyForCustomizedFontSize(
            "Fecha de creación",
            "11px",
            "null",
            "bold"
          )}
          {typographyForText(
            new Date(data.createdAt).toLocaleDateString("es-ES", options)
          )}
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Button
          sx={{ fontSize: "10px" }}
          color="secondary"
          size="small"
          startIcon={!showDetails ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? "ver menos información" : "ver más información"}
        </Button>
      </Grid>
      {showDetails && (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Stack
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
              >
                {typographyForCustomizedFontSize(
                  "Usuario generador",
                  "11px",
                  "null",
                  "bold"
                )}
                {typographyForText(data.createdBy)}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
